import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { Icon } from '@workboard/action-item';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import { type WithTranslation } from '../../../types/common.types';

import { formatDate, parseDate } from '../../../../utils/date';
import ImgIconComp from '../../../../components/imgcomp';
import OwnerListComp from '../../../components/sidePanel/components/ownerList';
import {
  AutomationProps,
  AutomationTypeState,
} from '../../../types/sidePanel.types';
import BoardService from '../../../services/board.service';
import { updateColumnAutomationData } from '../../../actions/column.actions';
import { constructAiAutomationData, getAiTypeDefinitions } from '../../../utils';
import { DropdownList } from './dropdown-list';
import { TItem } from '../../../types/automation.types';

const ActivityTypeWrapper = styled.div`
  margin: 10px 0px 20px;
`;
const ActivityTypeLabelWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin: 10px 0px 0px;
  svg {
    vertical-align: middle;
  }
`;

const ReactTags = require('react-tag-autocomplete');

const boardService = new BoardService();


class ColAutomationActionPopUpComp extends React.Component<
  WithTranslation<AutomationProps>,
  AutomationTypeState
> {
  datepicker: JQuery<any>

  constructor(props: WithTranslation<AutomationProps>) {
    super(props)
    const { data, t } = this.props;
    const { owner, duedate, notify_people } = data;

    this.state = {
      showListPopup: '',
      ownerTitle: owner.title === 'None' ? t('None') : owner.title,
      ownerVal: owner.id,
      dueDateVal: duedate.due_date,
      extendDays: duedate.extend_due_date_days,
      clearDate: duedate.clear_date,
      notify_people: notify_people.value,
      suggestions: [],
      ...this.getTypesData(data),
    }
    this.showDatePicker = this.showDatePicker.bind(this);
    this.handleDueDateChange = this.handleDueDateChange.bind(this);
    this.hideShowListPopup = this.hideShowListPopup.bind(this);
    this.closeColAutomationBox = this.closeColAutomationBox.bind(this);
    this.onShowListPopup = this.onShowListPopup.bind(this);
    this.setClearDate = this.setClearDate.bind(this);
    this.getAssigneeList = this.getAssigneeList.bind(this);
    this.bodyClickEventListener = this.bodyClickEventListener.bind(this);
    this.onDone = this.onDone.bind(this);
    this.onReset = this.onReset.bind(this);
    this.saveTitleAndValue = this.saveTitleAndValue.bind(this);
    this.changeExtendDays = this.changeExtendDays.bind(this);
    this.isNumber = this.isNumber.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleAddition = this.handleAddition.bind(this);
    this.tagComponent = this.tagComponent.bind(this);
    this.handleTagBlur = this.handleTagBlur.bind(this);
    this.saveActivityTypeValue = this.saveActivityTypeValue.bind(this);
  }

  private dueDatePicker = React.createRef<DayPickerInput>()

  hideShowListPopup() {
    this.setState({ showListPopup: '' })
  }

  closeColAutomationBox() {
    ($(colAutomationPopUp) as any).dialog('close')
    if (document.getElementById('colAutomationData')) {
      ReactDOM.unmountComponentAtNode(
        document.getElementById('colAutomationData')
      )
    }
  }

  componentDidMount() {
    this.getAssigneeList()
  }

  onShowListPopup(view: string) {
    if (view) {
      this.setState({
        showListPopup: view,
      })
    }
  }

  async getAssigneeList() {
    const params: any = {};
    const { boardDetails } = this.props;
    const { tagId, teamId } = boardDetails;
    const _this = this
    params.automation = true
    params.teamId = teamId
    params.tagId = tagId
    const response = await boardService.getTeamMembersForAiAutomation(params)
    if (response.data.status == 'success') {
      const assigniL = response.data.response || []
      const suggestions = assigniL.map((i: any) => ({
        id: i.user_id,
        name: i.name,
      }))
      _this.setState({ suggestions })
    }
  }

  bodyClickEventListener(e: any) {
    if (
      !$('.wsBoardAiAttr').is(e.target) // if the target of the click isn't the container...
      && $('.wsBoardAiAttr').has(e.target).length === 0
    ) {
      this.hideShowListPopup();
    }
  }

  onReset() {
    const { t } = this.props;
    this.setState({
      showListPopup: '',
      ownerTitle: t('None'),
      ownerVal: '',
      dueDateVal: '',
      extendDays: '',
      notify_people: [],
      clearDate: '',
      ...this.getTypesData(),
    })
  }

  async onDone() {
    const {
      columnId, data, onClose, dispatch
    } = this.props;
    const { duedate } = data;
    const { notify_people, extendDays, clearDate } = this.state;

    const actAutomationParams: Record<string, unknown> = {};
    ($ as any).each(
      $(this.refs.actAutomationForm).serializeArray(),
      function () {
        actAutomationParams[this.name] = this.value;
      }
    )

    showLoaderWidget($('#content'));
    const oldExtendDays = duedate.extend_due_date_days;
    const oldDueDate = duedate.due_date;
    const notifyPeople = notify_people.map((i: any) => i.id);
    actAutomationParams.columnId = columnId;
    actAutomationParams.extend_due_date_days = extendDays;
    actAutomationParams.oldextendDays = oldExtendDays;

    actAutomationParams.oldDueDate = oldDueDate;
    actAutomationParams.notify_people = notifyPeople.length
      ? notifyPeople
      : '';
    actAutomationParams.clear_date = clearDate;
    Object.assign(actAutomationParams, this.getTypesData(this.state));

    const response = await boardService.saveColAutomationAiData(
      actAutomationParams
    );
    onClose();
    if (
      response
      && response.data.status == 'success'
      && response.data.response
    ) {
      const aiResponse = response.data.response;
      const params: any = constructAiAutomationData(aiResponse);
      dispatch(
        updateColumnAutomationData(columnId, aiResponse.isAutomated, params)
      );
    }
    removeLoaderWidget();
  }

  saveTitleAndValue(
    title: string,
    titleVal: string,
    inputName: string,
    inpVal: string
  ) {
    // Need to check hoew it works
    this.setState({
      [`${title}`]: titleVal,
      [`${inputName}`]: inpVal,
    })
    this.hideShowListPopup()
  }

  saveActivityTypeValue(typeId: string, name: string, item: TItem) {
    this.setState({
      [`${typeId}`]: {
        ...this.state[typeId],
        [`${name}`]: item
      }
    }, () => {
      this.hideShowListPopup();
    });
  }

  setClearDate(isTrue = true) {
    this.setState({ clearDate: isTrue })
  }

  showDatePicker() {
    this.dueDatePicker.current.showDayPicker()
  }

  cleanDate(to: any) {
    this.setState({
      clearDate: this.props.data.duedate.clear_date,
      dueDateVal: this.props.data.duedate.due_date,
    })
    $('#ColAutoDatePick').val(null)
    this.dueDatePicker.current.hideDayPicker()
  }

  handleDueDateChange(selectedDay: any) {
    const dueDate = moment(selectedDay).format('M/DD/YYYY')
    this.setState({ dueDateVal: dueDate, clearDate: '' })
  }

  changeExtendDays(e: any) {
    e.preventDefault()
    let v = e.target.value.trim()
    if (v == '0' || v == '' || v == null || this.isNumber(v)) {
      v = parseInt(v)
      v = isNaN(v) ? '' : v
      this.setState({ extendDays: v })
    }
  }

  isNumber(val: any) {
    return val >= 0 && /^\d+$/.test(val)
  }

  handleDelete(i: any) {
    const notify_people = this.state.notify_people.slice(0)
    notify_people.splice(i, 1)
    this.setState({ notify_people })
  }

  handleAddition(tag: any) {
    // remove duplicates
    const foundItem = this.state.notify_people.find(
      (item: any) => item.id == tag.id
    )
    if (!foundItem) {
      const notify_people = [].concat(this.state.notify_people, tag)
      this.setState({ notify_people })
    }
  }

  tagComponent(props: any) {
    return (
      <div className={props.classNames.selectedTag}>
        <div className={`divInlineBlock ${props.classNames.selectedTagName}`}>
          {props.tag.name}
        </div>
        <div
          className="divInlineBlock reacttags__remove_icon"
          onClick={props.onDelete}
        >
          <ImgIconComp id="close" width="8" height="8" />
        </div>
      </div>
    )
  }

  handleTagBlur() {
    $('input[aria-owns="ReactTags-listbox"]').val('')
    setTimeout(() => {
      $('input[aria-owns="ReactTags-listbox"]').val('')
    }, 300)
  }

  getTypesData(data = null) {
    const result = {};
    getAiTypeDefinitions().forEach(({ id }) => {
      const key = `type_${id}`;
      result[key] = data?.[key] || {};
    });
    return result;
  }

  render() {
    const { columnId, boardDetails, t } = this.props
    const { tagId, teamId } = boardDetails;
    const disabledExtendDays = {}
    const {
      suggestions, showListPopup, ownerTitle, ownerVal,
      dueDateVal, clearDate, extendDays, notify_people
    } = this.state
    const today = new Date()
    const types = getAiTypeDefinitions();

    return (
      <form
        id="actAutomationForm"
        ref="actAutomationForm"
        key={`ai_automation_${columnId}`}
      >
        <div className="wbmodal wbmodal-share">
          <div
            className="wbmodal-content"
            style={{ padding: '0px', marginLeft: '5px' }}
          >
            <div className="colmunAutoTitle setWeightData">
              <span>{t('When an item is moved to this column, update these attributes')}:</span>
            </div>
            <div style={{ margin: '5px 0px' }}>
              {t('All Items:')}
            </div>
            <div className="colmunAutoTitle">
              <div className="ColAutoName">{t('Owner')}</div>
              <div
                className="ColAutoActionBorder"
                onClick={() => this.onShowListPopup('owner')}
              >
                <span className="aiOwnerValue truncateText">
                  {ownerTitle}
                </span>
                <span className="colAutoDropImage" />
              </div>
              <div className="wsBoardOwnerListWrapper wsBoardAiAttrListDiv wsBoardAiAttr colAttrDiv">
                {showListPopup == 'owner' ? (
                  <OwnerListComp
                    hideShowListPopup={this.hideShowListPopup}
                    srcVal="automation"
                    teamId={teamId}
                    tagId={tagId}
                    saveTitleAndValue={this.saveTitleAndValue}
                  />
                ) : null}
              </div>
              <input
                type="hidden"
                name="autoActowner"
                value={ownerVal}
              />
            </div>
            <div className="colmunAutoTitle">
              <div className="ColAutoName">{t('Due date')}</div>
              <DayPickerInput
                ref={this.dueDatePicker}
                format="MMM DD, YYYY"
                value={dueDateVal}
                formatDate={formatDate}
                parseDate={parseDate}
                placeholder={clearDate ? t('No Date') : t('None')}
                inputProps={{
                  id: 'ColAutoDatePick',
                  className: 'ColAutoDatePicker',
                  name: 'colAutoActionDuedate',
                  type: 'text',
                  readOnly: true,
                  autoComplete: 'off',
                }}
                dayPickerProps={{
                  disabledDays: { before: today },
                  fromMonth: today,
                  todayButton: t('Reset'),
                  onTodayButtonClick: (today) => this.cleanDate(today),
                }}
                keepFocus={false}
                onDayChange={this.handleDueDateChange}
                onClick={() => this.showDatePicker()}
              />
              <div
                className="colAutoDuedate"
                onClick={() => this.showDatePicker()}
              >
                <ImgIconComp id="calendar" width="14" height="14" />
              </div>
            </div>
            <div className="colmunAutoTitle">
              <Trans
                i18nKey="workstream.automation.extendDueDate"
                components={{
                  LabelDiv: <div className="ColAutoName" style={{ width: '35%' }} />,
                  InputContainer: <div style={{ display: 'inline-block' }} />,
                  Input: <input
                    type="text"
                    className="automation-extend-days"
                    ref="extend_due_date"
                    {...disabledExtendDays}
                    value={extendDays}
                    onChange={(e) => this.changeExtendDays(e)}
                  />,
                  DaysText: <span className="automation-days-text" />
                }}
              />
            </div>
            <div className="colmunAutoTitle setWeightData">
              <div
                className="ColAutoName"
                style={{ width: '35%', paddingBottom: '5px' }}
              >
                {t('Notify these people')}:
              </div>
              <div>
                <ReactTags
                  placeholder={
                    notify_people.length > 0
                      ? ''
                      : t('Search by person')
                  }
                  tags={notify_people}
                  suggestions={suggestions}
                  tagComponent={this.tagComponent}
                  handleAddition={this.handleAddition}
                  handleDelete={this.handleDelete}
                  minQueryLength={1}
                  handleBlur={this.handleTagBlur}
                  handleFocus={this.handleTagBlur}
                />
              </div>
            </div>
            {
              types?.map((type) => (
                <ActivityTypeWrapper key={`ai_issue_types_${type.id}`}>
                  <ActivityTypeLabelWrapper>
                    <Icon name={type.icons.component} width="15" height="15" />
                    <span>{type.label}</span>
                  </ActivityTypeLabelWrapper>
                  <div>
                    {Object.entries(type.attributes).map((object) => (
                      <DropdownList
                        key={`dropdown_list_${type.id}_${object[0]}`}
                        name={object[0]}
                        label={object[1].label}
                        values={object[1].values}
                        activityType={`${type.id}`}
                        srcVal="automation"
                        showListPopup={showListPopup}
                        saveActivityTypeValue={this.saveActivityTypeValue}
                        hideShowListPopup={this.hideShowListPopup}
                        onShowListPopup={this.onShowListPopup}
                        value={this.state[`type_${type.id}`]?.[object[0]]?.label ?? t('None')}
                      />
                    ))}
                  </div>
                </ActivityTypeWrapper>
              ))
            }
          </div>
        </div>
      </form>
    )
  }
}

// Wrap the component with forwardRef to support refs
const ColAutomationActionPopUpCompWithRef = React.forwardRef<
  ColAutomationActionPopUpComp,
  WithTranslation<AutomationProps>
>((props, ref) => (<ColAutomationActionPopUpComp {...props} ref={ref} />));

export default ColAutomationActionPopUpCompWithRef;
